const useLocalStorage = () => {
  try {
    return localStorage
  } catch {
    return undefined
  }
}

export default useLocalStorage
